import { labelsConstants, LabelType } from '@constants/labels';
import { labelsService } from '@services';

const setLabels = data => {
    return { type: labelsConstants.LABELS_SUCCESS, payload: data };
};

const failure = () => {
    return { type: labelsConstants.LABELS_ERROR };
};

const get = () => {
    return dispatch => {
        labelsService.getLabels(LabelType.Contact).then(
            data => dispatch(setLabels(data)),
            () => dispatch(failure()),
        );
    };
};

export const labelsActions = {
    get,
};
